import { IDropdownOption, Label, elementContains } from 'office-ui-fabric-react';
import {
    IConditionConfig, OutputReferenceHelper, IQueryBuilderRule, ModalHelper, IQueryBuilderConfigRule,
    IValidateExpressionResponse, EOutputLookupContext
} from './';
import { getExpressionFromJSON, getJSONFromExpression, getValidateExpression } from './io';
import { Promise } from 'es6-promise';
import store from '../store/store';
import types from '../store/types';
import { DEFAULT_JOURNEY_ID, QUERY_BUILDER_OPERATORS, VIEW_FILTER_QUERY_BUILDER_OPERATORS } from '../constants/index';

declare var tinymce;
declare var jQuery;
export class QueryBuilderHelper {

    private containerId: string;
    private propertyOptions: IDropdownOption[];
    private allRules: IQueryBuilderRule[];
    private hydrating: boolean;
    private onChange: (queryBuilderConfig: IConditionConfig) => void;
    private editorMarkupForHydrating: string[] = [];
    private loadQueryBuilderOnUpdate: boolean;
    private outputLookupContext: EOutputLookupContext;
    public forceApplyConfig: boolean;

    constructor(containerId: string, propertyOptions: IDropdownOption[], outputLookupContext: EOutputLookupContext, onChange: (queryBuilderConfig: IConditionConfig) => void, loadQueryBuilderOnUpdate: boolean = false) {

        this.onChange = onChange;
        this.allRules = [];
        this.hydrating = true;
        this.containerId = containerId;
        this.forceApplyConfig = false;

        let propertyKeys: string[] = propertyOptions && propertyOptions.map(p => p.key.toString());
        let uniquePropertyKeys: string[] = [];
        let uniquePropertyOptions: IDropdownOption[] = [];
        if (propertyOptions && propertyOptions.length)
            jQuery.each(propertyOptions, function (i, e) {
                if (jQuery.inArray(e.key, uniquePropertyKeys) === -1) {
                    uniquePropertyKeys.push(e.key);
                    uniquePropertyOptions.push(e);
                }
            });
        this.propertyOptions = uniquePropertyOptions;
        this.loadQueryBuilderOnUpdate = loadQueryBuilderOnUpdate;
        this.outputLookupContext = outputLookupContext;
    }

    public getForceApplyConfig = (): boolean => {
        return this.forceApplyConfig;
    }

    public setForceApplyConfig = (val: boolean): void => {
        this.forceApplyConfig = val;
    }

    public setLoadQueryBuilderOnUpdate(newValue: boolean): void {
        this.loadQueryBuilderOnUpdate = newValue;
    }

    public getLoadQueryBuilderOnUpdate(): boolean {
        return this.loadQueryBuilderOnUpdate;
    }

    private static getQueryEditorErrorIdentifier(propertyId?: string) {
        return (propertyId ? '#query-builder-wrapper-' + propertyId + ' ' : '') +
            '.rule-container.has-error, .rules-group-container.has-error, ' +
            (propertyId ? '#query-builder-wrapper-' + propertyId + ' ' : '') +
            '.query-builder-not-valid-expression, ' +
            (propertyId ? '#query-builder-wrapper-' + propertyId + ' ' : '') +
            '.query-builder-validating';
    }

    public static goToFirstQueryEditorError() {
        let identifier = QueryBuilderHelper.getQueryEditorErrorIdentifier();
        if (jQuery(identifier).length) {
            let offset = jQuery(identifier).position();
            let parentOffset = jQuery(identifier).offsetParent().position();
            ModalHelper.scrollTo(parentOffset.top + offset.top, true);
        }
    }

    public static hasOpenQueryEditor(): boolean {
        return !!jQuery('.query-builder-wrapper').length;
    }

    public static goToFirstOpenQueryEditor() {
        let identifier = '.query-builder-wrapper';
        if (jQuery(identifier).length) {
            let offset = jQuery(identifier).position();
            let parentOffset = jQuery(identifier).offsetParent().position();
            ModalHelper.scrollTo(parentOffset.top + offset.top, true);
        }
    }

    public static advancedQueryIsValidating(propertyId?: string) {
        return jQuery(
            (propertyId ? '#query-builder-wrapper-' + propertyId + ' ' : '') + '.query-builder-validating'
        ).length > 0;
    }

    public static canSaveQueryEditor(propertyId?: string) {
        let identifier = QueryBuilderHelper.getQueryEditorErrorIdentifier(propertyId);

        return jQuery(identifier).length === 0;
    }

    public static hasJourneyBeenSaved(): boolean {
        let journeyId = store.getState().toolsState.journeyId;
        return journeyId && journeyId.length && journeyId !== DEFAULT_JOURNEY_ID;
    }

    public static validateQueryBuilder(containerId: string): void {
        jQuery("#" + containerId).queryBuilder("getRules", { skip_empty: true, allow_invalid: false });
    }

    public convertToAdvancedMode(): Promise<IConditionConfig> {
        let existingConfig: IConditionConfig = this.getQueryBuilderConfig(true, true);

        let p: Promise<IConditionConfig> = new Promise<IConditionConfig>((resolve, reject) => {

            if (!existingConfig.Config.rules || !existingConfig.Config.rules.length) {
                //nullify non-advanced mode config
                existingConfig.Config = null;
                existingConfig.EditorMarkupArray = null;
                existingConfig.AdvancedMode = true;
                existingConfig.AdvancedConfig = JSON.stringify({
                    text: '',
                    markup: ''
                });
                resolve(existingConfig);
            }
            else {
                getExpressionFromJSON(existingConfig.Config).then(advancedConfig => {
                    //nullify non-advanced mode config
                    existingConfig.Config = null;
                    existingConfig.EditorMarkupArray = null;

                    //handle response and set AdvancedConfig
                    existingConfig.AdvancedMode = true;
                    existingConfig.AdvancedConfig = JSON.stringify({
                        text: advancedConfig,
                        markup: advancedConfig
                    });

                    resolve(existingConfig);
                });
            }


        });

        return p;
    }

    public convertFromAdvancedMode(expression: string): Promise<IConditionConfig> {
        let p: Promise<IConditionConfig> = new Promise<IConditionConfig>((resolve, reject) => {

            if (!expression.length) {
                let config: IConditionConfig = {
                    Config: null,
                    EditorMarkupArray: null,
                    AdvancedConfig: null,
                    AdvancedMode: false
                };
                resolve(config);
            }
            else {
                getJSONFromExpression(expression).then(config => {
                    if (config.EditorMarkupArray && config.EditorMarkupArray.length) {
                        config.EditorMarkupArray = config.EditorMarkupArray.map(m => OutputReferenceHelper.decodeTokens(m, this.propertyOptions));
                    }
                    config.AdvancedMode = false;
                    config.AdvancedConfig = null;
                    resolve(config);
                });
            }

        });

        return p;
    }

    public validateExpression(expression: string): Promise<IValidateExpressionResponse> {

        let p: Promise<IValidateExpressionResponse> = new Promise<IValidateExpressionResponse>((resolve, reject) => {

            if (!expression.length) {
                resolve({
                    isExpressionValid: true,
                    validationMessages: []
                });
            }
            else {
                getValidateExpression(expression).then((validateExpressionResponse: IValidateExpressionResponse) => {
                    resolve(validateExpressionResponse);
                });
            }

        });

        return p;
    }

    private cleanupRuleFilters(rules: IQueryBuilderConfigRule[]) {
        rules.forEach(r => {
            if (r.rules) {
                this.cleanupRuleFilters(r.rules);
            }
            else if (!this.propertyOptions.some(o => o.key === r.id) || !r.id.length) {
                r.id = '-1';
            }
            else if (!r.id.length) {
                r = {
                    id: "-1",
                    operator: "Equals",
                    type: "text"
                }
            }
        });
    }

    public applyQueryBuilderConfig(queryBuilderConfig: IConditionConfig, defaultOption?: IDropdownOption) {
        if (!queryBuilderConfig || !queryBuilderConfig.Config) {
            this.hydrating = false;
            return;
        }

        this.hydrating = true;
        this.editorMarkupForHydrating = queryBuilderConfig.EditorMarkupArray && queryBuilderConfig.EditorMarkupArray.length ?
            queryBuilderConfig.EditorMarkupArray.slice(0) : [];

        if (queryBuilderConfig.Config.rules && queryBuilderConfig.Config.rules.length) {
            if (defaultOption && queryBuilderConfig.Config.rules.length == 1 && !queryBuilderConfig.Config.rules[0].value) {
                let defaultRule: IQueryBuilderConfigRule;
                defaultRule = ({
                    field: defaultOption.key.toString(),
                    id: defaultOption.key.toString(),
                    input: "text",
                    operator: "Contains",
                    type: "string",
                    value: ""
                });
                queryBuilderConfig.Config.rules[0] = defaultRule;
            }
            this.cleanupRuleFilters(queryBuilderConfig.Config.rules);
            jQuery('#' + this.containerId).queryBuilder("setRules", queryBuilderConfig.Config);
        }

    }

    public initialiseQueryBuilder(allowEmpty?: boolean, defaultOption?: IDropdownOption, isViewFilter?: boolean) {

        // if (this.propertyOptions && this.propertyOptions.length) {

        jQuery('#' + this.containerId).queryBuilder({
            allow_empty: allowEmpty,
            operators: isViewFilter ? VIEW_FILTER_QUERY_BUILDER_OPERATORS : QUERY_BUILDER_OPERATORS,
            filters: this.propertyOptions.filter(po => po.key && po.key.toString().length).map(po => {
                return {
                    id: po.key,
                    label: po.text,
                    type: 'string'
                };
            })
        })
            .on('afterUpdateRuleOperator.queryBuilder', this.afterUpdateRuleOperator)
            .on('afterUpdateRuleFilter.queryBuilder', this.afterUpdateRuleFilter)
            .on('afterSetRules.queryBuilder', this.afterSetRules)
            .on('beforeDeleteRule.queryBuilder', this.beforeDeleteRule)
            .on('beforeDeleteGroup.queryBuilder', this.beforeDeleteGroup)
            .on('afterDeleteRule.queryBuilder', () => {
                this.afterDeleteRule(defaultOption);
            })
            .on('afterDeleteGroup.queryBuilder', this.afterDeleteGroup)
            .on('afterAddRule.queryBuilder', (event, rule) => {
                this.afterAddRule(event, rule, defaultOption);
            })
            .on('afterUpdateGroupCondition.queryBuilder', (event, rule) => {
                this.afterUpdateGroupCondition(event, rule, defaultOption);
            })
            ;

        jQuery('.rule-container').addClass('empty-rule');
        // }

    }

    public updatePropertyOptions(propertyOptions: IDropdownOption[]) {
        this.propertyOptions = propertyOptions;

    }


    public reinitialiseQueryBuilder(allowEmpty?: boolean, defaultOption?: IDropdownOption, propertyOptions?: IDropdownOption[], isViewFilter?: boolean) {
        this.cleanup();
        jQuery('#' + this.containerId).queryBuilder('destroy');

        if (propertyOptions) {
            this.propertyOptions = propertyOptions;
        }

        jQuery('#' + this.containerId).queryBuilder({
            allow_empty: allowEmpty,
            operators: isViewFilter ? VIEW_FILTER_QUERY_BUILDER_OPERATORS : QUERY_BUILDER_OPERATORS,
            filters: this.propertyOptions.filter(po => po.key && po.key.toString().length).map(po => {
                return {
                    id: po.key,
                    label: po.text,
                    type: 'string'
                };
            })
        })
            .on('afterUpdateRuleOperator.queryBuilder', this.afterUpdateRuleOperator)
            .on('afterUpdateRuleFilter.queryBuilder', this.afterUpdateRuleFilter)
            .on('afterSetRules.queryBuilder', this.afterSetRules)
            .on('beforeDeleteRule.queryBuilder', this.beforeDeleteRule)
            .on('beforeDeleteGroup.queryBuilder', this.beforeDeleteGroup)
            .on('afterDeleteRule.queryBuilder', () => {
                this.afterDeleteRule(defaultOption);
            })
            .on('afterDeleteGroup.queryBuilder', this.afterDeleteGroup)
            .on('afterAddRule.queryBuilder', (event, rule) => {
                this.afterAddRule(event, rule, defaultOption);
            })
            .on('afterUpdateGroupCondition.queryBuilder', (event, rule) => {
                this.afterUpdateGroupCondition(event, rule, defaultOption);
            })
            ;

        jQuery('.rule-container').addClass('empty-rule');

        let propertyKeys: string[] = propertyOptions && propertyOptions.map(p => p.key.toString());
        let uniquePropertyKeys: string[] = [];
        let uniquePropertyOptions: IDropdownOption[] = [];
        if (propertyOptions && propertyOptions.length)
            jQuery.each(propertyOptions, function (i, e) {
                if (jQuery.inArray(e.key, uniquePropertyKeys) === -1) {
                    uniquePropertyKeys.push(e.key);
                    uniquePropertyOptions.push(e);
                }
            });
        this.propertyOptions = uniquePropertyOptions;

    }

    public cleanup(stopEditingBranch?: boolean): void {

        jQuery('#' + this.containerId).queryBuilder("destroy");

        for (let i = 0; i < this.allRules.length; i++) {
            if (this.allRules[i] && this.allRules[i].editorId) {
                let editor = tinymce.get(this.allRules[i].editorId);
                if (editor) {
                    tinymce.remove(editor);
                }
            }
        }

        this.allRules = [];

        if (stopEditingBranch) {
            store.dispatch({
                type: types.SET_BRANCH_EDIT_INDEX,
                branchIndex: null
            });
        }

        store.dispatch({
            type: types.SET_OUTPUT_SEARCH,
            searchElementId: null,
            searchTerm: '',
            offsetTop: null
        });

    }

    private sendOutChange = (defaultOption?: IDropdownOption) => {
        let saveOnBlur = OutputReferenceHelper.getSaveOnBlur();

        if (!this.hydrating) {
            let queryBuilderConfig = this.getQueryBuilderConfig(false, true);

            if (defaultOption && queryBuilderConfig.Config.rules && queryBuilderConfig.Config.rules.length) {
                this.setDefaultRule(queryBuilderConfig, queryBuilderConfig.Config.rules, defaultOption);

                queryBuilderConfig.EditorMarkupArray.forEach((editorMarkup, i) => {
                    if (editorMarkup == null) {
                        queryBuilderConfig.EditorMarkupArray[i] = "<p><br data-mce-bogus=\"1\"></p>";
                    }
                });

                this.forceApplyConfig = true;
            }
            else if (queryBuilderConfig.Config.rules.length === 0) {
                // there are no rules left, so reset the query builder config
                queryBuilderConfig.Config.condition = "AND";
                queryBuilderConfig.EditorMarkupArray = [];

                let defaultRule = defaultOption && defaultOption.key ? {
                    field: defaultOption.key.toString(),
                    id: defaultOption.key.toString(),
                    input: "text",
                    operator: "Contains",
                    type: "string",
                    value: ""
                } : {
                    id: "-1",
                    operator: "Equals",
                    type: "text"
                };

                queryBuilderConfig.Config.rules = [defaultRule];
                this.forceApplyConfig = true;
            }
            else if (queryBuilderConfig.Config.rules.length === 1) {
                let onlyRule = queryBuilderConfig.Config.rules[0];
                if (onlyRule.field === null && onlyRule.id === null && onlyRule.input === null && onlyRule.operator === null && onlyRule.type === null) {
                    // the only remaining rule is blank, so reset the query builder config
                    queryBuilderConfig.Config.condition = "AND";
                    queryBuilderConfig.EditorMarkupArray = [];

                    let defaultRule = defaultOption && defaultOption.key ? {
                        field: defaultOption.key.toString(),
                        id: defaultOption.key.toString(),
                        input: "text",
                        operator: "Contains",
                        type: "string",
                        value: ""
                    } : {
                        id: "-1",
                        operator: "Equals",
                        type: "text"
                    };

                    queryBuilderConfig.Config.rules = [defaultRule];
                    this.forceApplyConfig = true;
                }
            }

            this.onChange(queryBuilderConfig);

            OutputReferenceHelper.clearOutputReferenceSearch();

        }
    }

    private setDefaultRule = (queryBuilderConfig: IConditionConfig, rules: IQueryBuilderConfigRule[], defaultOption: IDropdownOption) => {
        rules.forEach((rule) => {
            if (rule.rules) {
                this.setDefaultRule(queryBuilderConfig, rule.rules, defaultOption);
            } else if (rule.id == null) {
                rule.field = defaultOption.key.toString();
                rule.id = defaultOption.key.toString();
                rule.input = "text";
                rule.operator = "Contains";
                rule.type = "string";
                rule.value = "";
            }
        });
    }

    private getQueryBuilderConfig = (skipEmptyRules: boolean, allowInvalidRules: boolean): IConditionConfig => {
        let config = jQuery("#" + this.containerId).queryBuilder("getRules", { skip_empty: skipEmptyRules, allow_invalid: allowInvalidRules });
        let identifier = "#" + this.containerId + " .rule-container";

        let editorMarkupArray = [];
        let _queryBuilderHelperInstance = this;
        jQuery(identifier).each(function (i) {
            let ruleId = jQuery(this).attr("id");
            let ruleIndex: number = _queryBuilderHelperInstance.getRuleIndex(ruleId);
            let editorMarkup: string = _queryBuilderHelperInstance.allRules && _queryBuilderHelperInstance.allRules[ruleIndex] ?
                _queryBuilderHelperInstance.allRules[ruleIndex].editorMarkup : null;
            editorMarkupArray.push(editorMarkup);
        });

        return {
            Config: config,
            EditorMarkupArray: editorMarkupArray
        };
    }

    private afterAddRule = (event: any, rule: any, defaultOption?: IDropdownOption) => {
        if (!rule.filter) {
            jQuery('#' + rule.id).addClass('empty-rule');
            this.sendOutChange(defaultOption);
        }
    }

    private afterSetRules = (event: any) => {
        this.hydrating = false;
    }

    private afterUpdateRuleFilter = (event: any, rule: any, previousFilter: any) => {
        let ruleIndex: number = this.getRuleIndex(rule.id);
        let editorMarkup: string = '';
        let existingRule = this.allRules.filter(r => r && r.rule.id === rule.id)[0];
        if (existingRule) {
            editorMarkup = existingRule.editorMarkup;
            let existingEditor = tinymce.get(existingRule.editorId);
            if (existingEditor) {
                tinymce.remove(existingEditor);
            }
        }
        let initHydrating = !!this.hydrating;
        if (rule.filter || !existingRule) {
            this.initTinyMceForRule(rule, editorMarkup, initHydrating);
        }
        else {
            jQuery('#' + rule.id).addClass('empty-rule');
            existingRule.editorId = null;
            existingRule.editorMarkup = null;
        }


        this.sendOutChange();
        if (!rule.filter) {
            jQuery('#' + rule.id).removeClass('has-error');
        }
    }

    private afterUpdateRuleOperator = (event: any, rule: any, previousOperator: any) => {
        if (rule.operator.type === 'Is Empty' || rule.operator.type === 'Is Not Empty') {
            jQuery('#' + this.containerId + ' #' + rule.id).addClass('hide-editor');
            let ruleIndex: number = this.getRuleIndex(rule.id);
            let editor = this.allRules[ruleIndex] && this.allRules[ruleIndex].editorId ? tinymce.get(this.allRules[ruleIndex].editorId) : null;
            if (editor) {
                editor.setContent('<p>NA</p>');
                this.updateRuleValue(rule, editor, false);
            }
        }
        else if (previousOperator.type === 'Is Empty' || previousOperator.type === 'Is Not Empty') {
            jQuery('#' + this.containerId + ' #' + rule.id).removeClass('hide-editor');
            let ruleIndex: number = this.getRuleIndex(rule.id);
            let editor = tinymce.get(this.allRules[ruleIndex].editorId);
            editor.setContent('<p></p>');
            this.updateRuleValue(rule, editor, false);
        }
        this.sendOutChange();
    }

    private afterUpdateGroupCondition = (event: any, group: any, previousCondition: any, defaultOption?: IDropdownOption) => {
        this.sendOutChange(defaultOption);
    }

    private beforeDeleteRule = (event: any, rule: any) => {
        this.deleteRule(rule);
    }

    private beforeDeleteGroup = (event: any, group: any) => {
        this.deleteGroup(group);
    }

    private afterDeleteRule = (defaultOption?: IDropdownOption) => {
        this.sendOutChange(defaultOption);
    }

    private afterDeleteGroup = () => {
        this.sendOutChange();
    }

    private configureTinyMceForGroup = (group: any, editorMarkupArray: string[]) => {

    }

    private initTinyMceForRule = (rule: any, editorMarkup: string, hydrating: boolean) => {
        if (hydrating && this.editorMarkupForHydrating && this.editorMarkupForHydrating.length) {
            editorMarkup = this.editorMarkupForHydrating.shift();
        }
        tinymce.init({
            selector: '#' + this.containerId + ' .rule-value-container input.form-control[type="text"]',
            toolbar: false,
            menubar: false,
            statusbar: false,
            plugins: 'paste autoresize outputReference',
            extended_valid_elements: 'span[class|id|contenteditable|style|output-id|tabindex|title]',
            autoresize_bottom_margin: 0,
            autoresize_max_height: 350,
            content_style: 'html { overflow: hidden; }',
            body_class: document.body.className + ' single-line query-builder-value',
            content_css: ['/css/app.css', 'https://appsforoffice.microsoft.com/fabric/fabric-core/4.0.0/fabric.min.css'],
            setup: (editor) => {
                editor.on('blur', (event) => {
                    let scrollPoint = OutputReferenceHelper.getPostBlurModalScrollTop();
                    this.updateRuleValue(rule, editor, false);
                    if (scrollPoint) {
                        ModalHelper.scrollTo(scrollPoint);
                    }
                    OutputReferenceHelper.setLastBlurTimeStamp();
                    OutputReferenceHelper.clearOutputReferenceSearch();
                });
                editor.on('init', (event) => {
                    let ruleIndex: number = this.getRuleIndex(rule.id);
                    this.allRules[ruleIndex] = {
                        rule: rule,
                        editorId: editor.id,
                        editorMarkup: editorMarkup
                    };
                    jQuery('#' + rule.id).removeClass('empty-rule');

                    if (rule.operator.type === 'Is Empty' || rule.operator.type === 'Is Not Empty') {
                        editorMarkup = '<p>NA</p>';
                        jQuery('#' + this.containerId + ' #' + rule.id).addClass('hide-editor');
                    }
                    else {
                        jQuery('#' + this.containerId + ' #' + rule.id).removeClass('hide-editor');
                    }

                    editor.setContent(editorMarkup);
                    this.updateRuleValue(rule, editor, hydrating);
                    editor.plugins.paste.clipboard.pasteFormat = "text";
                    editor.plugins.outputReference.outputLookupContext = this.outputLookupContext;
                });
            }
        });
    }

    private deleteGroup = (group: any) => {
        for (let i = 0; i < group.rules.length; i++) {
            this.deleteRule(group.rules[i]);
        }
    }

    private deleteRule = (rule: any) => {
        if (rule.rules) {
            this.deleteGroup(rule);
        }
        else {
            let ruleIndex: number = this.getRuleIndex(rule.id);
            if (this.allRules[ruleIndex]) {
                let existingEditor = tinymce.get(this.allRules[ruleIndex].editorId);
                tinymce.remove(existingEditor);
                this.allRules[ruleIndex] = null;
            }
        }
    }

    private updateRuleValue = (rule: any, editor: any, hydrating: boolean) => {
        let elem = document.createElement("div");
        let editorMarkup = editor.getBody() ? editor.getBody().innerHTML : '';
        elem.innerHTML = OutputReferenceHelper.encodeTokens(editorMarkup);
        if (elem.innerHTML === '<p><br></p>' || elem.innerHTML.indexOf('data-mce-bogus="1"') >= 0) {
            elem.innerHTML = '<p></p>'; //fix for unexplained tinymce bug
        }
        let editorText = elem.innerText.replace(/\r?\n|\r/, '');
        rule.value = editorText;
        let allRulesEntry = this.allRules[this.getRuleIndex(rule.id)];
        if (allRulesEntry) {
            allRulesEntry.editorMarkup = editorMarkup;
        }
        if (!hydrating) {
            this.sendOutChange();
        }
    }

    private getRuleIndex = (ruleId: string): number => {
        return +(ruleId.replace(this.containerId, '').replace('_rule_', ''));
    }

}


// WEBPACK FOOTER //
// ./source/ts/helpers/query-builder.ts